import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { memo, useState } from "react";
import { useCollapse } from "react-collapsed";
import { useToggle } from "react-use";
import { ButtonBar } from "../elements";
import { CollapseChevron } from "../icons";
import { GasChart } from "./GasChart";
import { GasCostSummary } from "./GasCostSummary";
import { tracksSelector, useOptimistReportSelector } from "./state";
export const GasInfoCard = memo(({ chain }) => {
    const tracks = useOptimistReportSelector(state => tracksSelector(state));
    const [selectedTrackId, setSelectedTrackId] = useState(tracks[0].id);
    const [collapsed, toggleCollapsed] = useToggle(true);
    const { getCollapseProps, getToggleProps } = useCollapse({
        isExpanded: !collapsed,
        duration: 300,
    });
    return (_jsxs("div", { className: clsx("border rounded-xl mt-4 py-4", "border-slate-50", "bg-slate-800"), children: [_jsx("div", { ...getToggleProps({ onClick: toggleCollapsed }), children: _jsxs("div", { className: "flex flex-row items-center justify-between mx-4", children: [_jsx("h2", { children: "Gas stats" }), _jsx(CollapseChevron, { className: "fill-white", collapsed: collapsed })] }) }), _jsxs("div", { ...getCollapseProps(), className: "px-2", children: [_jsx("div", { className: "my-4 ml-12", children: _jsx(StatusBar, { tracks: tracks, selectedTrackId: selectedTrackId, onChangeTrack: setSelectedTrackId }) }), _jsx("div", { className: "mr-12", children: _jsx(GasChart, { selectedTrackId: selectedTrackId }) }), _jsx("div", { className: "mx-4 mt-4", children: _jsx(GasCostSummary, { selectedTrackId: selectedTrackId, chain: chain }) })] })] }));
});
GasInfoCard.displayName = "GasInfoCard";
const StatusBar = props => {
    const { tracks, selectedTrackId, onChangeTrack } = props;
    const buttons = tracks.map(t => ({
        id: t.id,
        title: t.name,
    }));
    return (_jsx(ButtonBar, { items: buttons, activeId: selectedTrackId, onChange: onChangeTrack, buttonClassName: "py-1! bg-white/10 hover:bg-black/10 has-checked:bg-black/20" }));
};
export default GasInfoCard;
